import {Breadcrumb} from '@/components-v2/molecules/Breadcrumb/Breadcrumb'
import {ProgressIndicator} from '@/components-v2/molecules/ProgressIndicator/ProgressIndicator'
import {HeaderTitle} from '@/components/atoms'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {ProductComboFooter} from '@/features/ProductCombo/ProductComboFooter'
import {ProductComboStep, ProductComboSteps} from '@/features/ProductCombo/ProductComboStep'
import {Header} from '@/utils/constants/header'
import {ROUTES} from '@/utils/constants/routesConstants'
import {
  productCombinationBreadcrumbUISchema,
  productCombinationProgressLevelSteps,
} from '@/utils/productCombo/productComboConstants'
import {useMatch} from 'react-router-dom'
import {PublishedComboHeader} from './ComboDetail/PublishedComboHeader'

export const CreateProductCombo = () => {
  const {
    currentStep,
    productCombo: {isDraft},
  } = useProductCombo()
  const isComboDetailPage = Boolean(useMatch(ROUTES.PRODUCT_COMBO_DETAIL))

  const isDetailsView = currentStep === ProductComboSteps.REVIEW && isComboDetailPage

  return (
    <div className="product-combo flex flex-col gap-4">
      <Breadcrumb breadcrumbs={productCombinationBreadcrumbUISchema} />
      {isDetailsView ? (
        <PublishedComboHeader />
      ) : (
        <>
          <HeaderTitle
            title={isDraft === false ? 'Edit Combo' : 'Create Combo'}
            headingLevel={Header.PageHeader}
            className="$font-heading-h3-bold"
          />
          <ProgressIndicator
            currentStep={currentStep}
            steps={4}
            titles={productCombinationProgressLevelSteps}
            className="p-6"
          />
        </>
      )}

      <ProductComboStep step={currentStep} />

      {!isDetailsView && <ProductComboFooter />}
    </div>
  )
}
